import React from "react";

import { useSelector } from "react-redux";
import styles from "./EmptyState.module.css";
import { translate } from "../../../../common/providers";
import { CustomButtonLink } from "../../../../common/components";
import { NavUtils } from "../../../../navigation";

const EmptyState = () => {
	const projectId = useSelector(({ context }) => context.project?.id);
	return (
		<div className={styles.container}>
			<span>{translate("notes.document-view.empty-state.title")}</span>
			<CustomButtonLink to={NavUtils.goToDocumentCenter(projectId)} variant="contained">
				{translate("notes.document-view.empty-state.button")}
			</CustomButtonLink>
		</div>
	);
};

export default EmptyState;
